import ColorField from './ColorField';
import { FRAME_FONTS, FRAME_TYPES } from '../../../utils/qrDesign';

const labelClass = 'mb-1.5 block text-sm font-medium text-slate-700';
const inputClass =
  'w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/20';

export default function FrameTab({ style, updateStyle }) {
  return (
    <div className="space-y-6">
      <div>
        <p className={labelClass}>Frame style</p>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
          {FRAME_TYPES.map((frame) => {
            const selected = style.frameType === frame.id;
            return (
              <button
                key={frame.id}
                type="button"
                onClick={() => updateStyle('frameType', frame.id)}
                className={`rounded-xl px-3 py-3 text-xs font-medium transition ${
                  selected
                    ? 'bg-indigo-600 text-white ring-2 ring-indigo-600'
                    : 'bg-white text-slate-600 ring-1 ring-slate-200 hover:bg-slate-50'
                }`}
              >
                {frame.label}
              </button>
            );
          })}
        </div>
      </div>

      {style.frameType === 'banner' && (
        <>
          <div>
            <label htmlFor="frame-phrase" className={labelClass}>
              Frame phrase
            </label>
            <input
              id="frame-phrase"
              type="text"
              className={inputClass}
              placeholder="SCAN ME"
              value={style.framePhrase}
              onChange={(e) => updateStyle('framePhrase', e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="frame-font" className={labelClass}>
              Phrase font
            </label>
            <select
              id="frame-font"
              className={inputClass}
              value={style.frameFont}
              onChange={(e) => updateStyle('frameFont', e.target.value)}
            >
              {FRAME_FONTS.map((f) => (
                <option key={f.id} value={f.id}>
                  {f.label}
                </option>
              ))}
            </select>
          </div>
          <div className="grid gap-6 sm:grid-cols-2">
            <ColorField
              id="frame-color"
              label="Frame color"
              value={style.frameColor}
              onChange={(v) => updateStyle('frameColor', v)}
            />
            <ColorField
              id="frame-text-color"
              label="Phrase color"
              value={style.frameTextColor}
              onChange={(v) => updateStyle('frameTextColor', v)}
            />
          </div>
        </>
      )}

      {(style.frameType === 'border' || style.frameType === 'rounded') && (
        <ColorField
          id="frame-color-only"
          label="Frame color"
          value={style.frameColor}
          onChange={(v) => updateStyle('frameColor', v)}
        />
      )}

      {style.frameType === 'none' && (
        <p className="text-sm text-slate-500">No frame — plain QR code only.</p>
      )}
    </div>
  );
}

